<script>
import DatePicker from "vue2-datepicker";
import cloneDeep from "lodash/cloneDeep";
import UploadPopover from "@/components/widgets/upload-popover.vue";

export default {
  page: {
    title: "Incoming Deliveries"
  },
  components: {
    DatePicker,
    UploadPopover
  },
  data() {
    return {
      submitted: false,
      modalTitle: "",
      poItem: null,
      userType: "",
      poDeliveryExtensions: [],
      form: {
        poId: null,
        from: "",
        to: "",
        dateRequested: "",
        requestedBy: "",
        remarks: "",
        withLiquidatedDamages: true
      },
      extensionId: 0,
      fileUpload: [],
      uploadExtensionType: 0,
      loading: false,
      editExtension: false,
      minDate: "",
      contractActionType: 0, // 0: Suspension, 1: Extension, 2: Termination, 3: Cancellation
      contractActionTypes: [
        { id: 0, name: "SUSPENSION", label: "Suspend Contract", icon: "mdi-calendar-range", btnClass: "info" },
        { id: 1, name: "EXTENSION", label: "Extend Contract", icon: "mdi-update", btnClass: "warning" },
        { id: 2, name: "TERMINATION", label: "Terminate Contract", icon: "mdi-close-circle", btnClass: "danger" },
        { id: 3, name: "CANCELLATION", label: "Cancel Contract", icon: "mdi-cancel", btnClass: "dark" }
      ],
      uploadOptions: {
        type: "Purchase Order",
        placement: "lefttop",
        folder: "Property"
      },
      uploadOptionsExtension: {
        type: "Delivery Extension",
        placement: "lefttop",
        folder: "Inspection"
      }
    };
  },
  methods: {
    async getSuspension(row, type) {
      this.poItem = row;
      this.poDeliveryExtensions = [];
      this.userType = type;
      this.loading = true;
      this.$store
        .dispatch(
          "inspectionextension/GetDeliveryExtensionByPo",
          this.poItem.id
        )
        .then((res) => {
          res.data.forEach((item) => {
            item.viewFile = false;
            item.extensionFiles = [];
            item.addDocu = false;
            item.attachmentLoading = false;
          });
          this.poDeliveryExtensions = res.data.reverse();
          this.$forceUpdate();
          this.loading = false;
        })
        .catch((err) => {
          let stringErr = err.toString();
          if (stringErr.includes("Network")) {
            this.showToast("Network Error!", "error");
          } else {
            this.showToast(
              "Something went wrong - Getting contract management!",
              "error"
            );
          }
          this.loading = false;
        });
    },
    onExtend() {
      this.submitted = true;
      if (
        this.form.poId == null ||
        this.form.from == null ||
        this.form.from == "" ||
        this.form.to == null ||
        this.form.to == "" ||
        this.form.requestedBy == null ||
        this.form.requestedBy == "" ||
        this.form.dateRequested == null ||
        this.form.dateRequested == "" ||
        (this.form.id == null &&
        (this.fileUpload == "" ||
        this.fileUpload == null ||
        this.fileUpload == []))
      ) {
        return;
      }
      var form = cloneDeep(this.form);
      form.dateRequested = this.getDate(this.form.dateRequested);
      form.from =
        this.getDate(this.form.from) != "1-01-01T00:00:00"
          ? this.getDate(this.form.from)
          : "01-01-01T00:00:00";
      form.to =
        this.getDate(this.form.to) != "1-01-01T00:00:00"
          ? this.getDate(this.form.to)
          : "01-01-01T00:00:00";        // Set type based on the selected contract action type
      form.type = this.contractActionTypes[this.contractActionType].name;
      if (this.editExtension) {
        this.$store
          .dispatch("inspectionextension/UpdateDeliveryExtension", form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            var extensionIndex = this.poDeliveryExtensions.findIndex(
              (item) => item.id == form.id
            );
            res.data.viewFile = false;
            res.data.extensionFiles = cloneDeep(form.extensionFiles);
            res.data.addDocu = false;
            res.data.attachmentLoading = false;
            this.poDeliveryExtensions.splice(extensionIndex, 1, res.data);
            this.showToast("Successfully updated!", "success");
            this.onReset();
            this.$bvModal.hide("modal-extension");
          })
          .catch((err) => {
            this.showToast("Something went wrong while updating!", "error");
          });
      } else {
        this.$store
          .dispatch("inspectionextension/CreateDeliveryExtension", form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            res.data.viewFile = false;
            res.data.extensionFiles = [];
            res.data.addDocu = false;
            res.data.attachmentLoading = false;
            this.poDeliveryExtensions = [res.data].concat(
              this.poDeliveryExtensions
            );
            let dashboardData = JSON.parse(
              localStorage.getItem("dashboardData")
            );
            dashboardData.pendingContractExtensions =
              dashboardData.pendingContractExtensions + 1;
            localStorage.setItem(
              "dashboardData",
              JSON.stringify(dashboardData)
            );
            this.uploadToServer(res.data.id);
            const actionType = this.contractActionTypes[this.contractActionType].name.toLowerCase();
            this.showToast(`Contract ${actionType} request submitted successfully!`, "success");
            this.onReset();
            this.$bvModal.hide("modal-extension");
          })
          .catch((err) => {
            this.showToast(
              "Something went wrong - Extending delivery date!",
              "error"
            );
          });
        this.submitted = false;
      }
    },
    createSuspension() {
      this.onReset();
      this.contractActionType = 0;
      this.form.poId = this.poItem.id;
      this.form.dateRequested = new Date();
      this.minDate = new Date(this.poItem.expectedDelivery);
      this.modalTitle = "Suspend Contract";
      this.$bvModal.show("modal-extension");
    },
    createExtension() {
      this.onReset();
      this.contractActionType = 1;
      this.form.poId = this.poItem.id;
      this.form.dateRequested = new Date();
      this.form.from = new Date(this.poItem.expectedDelivery);
      this.minDate = new Date(this.poItem.expectedDelivery);
      this.modalTitle = "Extend Contract";
      this.$bvModal.show("modal-extension");
    },
    createTermination() {
      this.onReset();
      this.contractActionType = 2;
      this.form.poId = this.poItem.id;
      this.form.dateRequested = new Date();
      this.form.from = new Date(); // Current date
      this.form.to = new Date(); // Same as from, as it's effective immediately
      this.minDate = new Date();
      this.modalTitle = "Terminate Contract";
      this.$bvModal.show("modal-extension");
    },
    createCancellation() {
      this.onReset();
      this.contractActionType = 3;
      this.form.poId = this.poItem.id;
      this.form.dateRequested = new Date();
      this.form.from = new Date(); // Current date
      this.form.to = new Date(); // Same as from, as it's effective immediately
      this.minDate = new Date();
      this.modalTitle = "Cancel Contract";
      this.$bvModal.show("modal-extension");
    }, updateExtension(props) {
      this.onReset();

      // Set the correct contract action type based on the type property
      switch (props.type) {
        case "EXTENSION":
          this.contractActionType = 1;
          break;
        case "SUSPENSION":
          this.contractActionType = 0;
          break;
        case "TERMINATION":
          this.contractActionType = 2;
          break;
        case "CANCELLATION":
          this.contractActionType = 3;
          break;
        default:
          this.contractActionType = 0;
      }

      this.form = cloneDeep(props);
      this.form.from = new Date(props.from);
      this.form.to = new Date(props.to);
      this.form.dateRequested = new Date(props.dateRequested);
      this.minDate = new Date(props.from);
      this.editExtension = true;
      this.modalTitle = "Update Contract";
      this.$bvModal.show("modal-extension");
    },
    deleteExtension(extensionId) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(
              "inspectionextension/DeleteDeliveryExtension",
              extensionId
            )
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var extensionIndex = this.poDeliveryExtensions.findIndex(
                (item) => item.id == extensionId
              );
              this.poDeliveryExtensions.splice(extensionIndex, 1);
              let dashboardData = JSON.parse(
                localStorage.getItem("dashboardData")
              );
              dashboardData.pendingContractExtensions =
                dashboardData.pendingContractExtensions - 1;
              localStorage.setItem(
                "dashboardData",
                JSON.stringify(dashboardData)
              );
              this.showToast("Successfully deleted", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    onApproveExtension() {
      this.submitted = true;
      if (
        this.fileUpload == "" ||
        this.fileUpload == null ||
        this.fileUpload == []
      ) {
        return;
      }
      this.$swal({
        title: "Are you sure?",
        text: "You are about to approve this request.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, approve request!"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(
              "inspectionextension/ApproveDeliveryExtension",
              this.extensionId
            )
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var extensionIndex = this.poDeliveryExtensions.findIndex(
                (item) => item.id == this.extensionId
              );
              this.poDeliveryExtensions[extensionIndex].status = "APPROVED";
              let dashboardData = JSON.parse(
                localStorage.getItem("dashboardData")
              );
              dashboardData.pendingContractExtensions =
                dashboardData.pendingContractExtensions - 1;
              localStorage.setItem(
                "dashboardData",
                JSON.stringify(dashboardData)
              );
              this.uploadToServer(this.extensionId);
              this.$bvModal.hide("modal-upload-extension");
              this.showToast("Successfully approved", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be approved!", "error");
            });
        }
      });
    },
    approveExtension(extensionId) {
      this.onReset();
      this.extensionId = extensionId;
      this.uploadExtensionType = 0; this.modalTitle = "Approve Action";
      this.$bvModal.show("modal-upload-extension");
    },
    onDisapproveExtension() {
      this.submitted = true;
      if (
        this.fileUpload == "" ||
        this.fileUpload == null ||
        this.fileUpload == []
      ) {
        return;
      }
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, deny request!"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(
              "inspectionextension/DisapproveDeliveryExtension",
              this.extensionId
            )
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var extensionIndex = this.poDeliveryExtensions.findIndex(
                (item) => item.id == this.extensionId
              );
              this.poDeliveryExtensions[extensionIndex].status = "DISAPPROVED";
              let dashboardData = JSON.parse(
                localStorage.getItem("dashboardData")
              );
              dashboardData.pendingContractExtensions =
                dashboardData.pendingContractExtensions - 1;
              localStorage.setItem(
                "dashboardData",
                JSON.stringify(dashboardData)
              );
              this.uploadToServer(this.extensionId);
              this.$bvModal.hide("modal-upload-extension");
              this.showToast("Successfully denied", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be denied!", "error");
            });
        }
      });
    },
    disapproveExtension(extensionId) {
      this.onReset();
      this.extensionId = extensionId;
      this.uploadExtensionType = 1;
      this.modalTitle = "Deny Extension";
      this.$bvModal.show("modal-upload-extension");
    },
    returnExtension(extensionId) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, undo request!"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$store
            .dispatch(
              "inspectionextension/ReturnDeliveryExtension",
              extensionId
            )
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              var extensionIndex = this.poDeliveryExtensions.findIndex(
                (item) => item.id == extensionId
              );
              this.poDeliveryExtensions[extensionIndex].status = "PENDING";
              this.showToast("Successfully undone", "success");
            })
            .catch((err) => {
              this.showToast("Cannot be undone!", "error");
            });
        }
      });
    },
    updateLiquidatedDamages(props) {
      this.$store
        .dispatch(
          "inspectionextension/UpdateDeliveryExtensionLiquidatedDamages",
          {
            id: props.id,
            status: props.withLiquidatedDamages
          }
        )
        .then((res) => {
          if (res.data.error) {
            this.showToast(
              "Cannot update info. " + res.data.errorMessage,
              "error"
            );
            return;
          }
          this.showToast("Status updated successfully", "success");
        })
        .catch((error) => {
          this.showToast("Something went wrong.", "error");
        });
    },
    onReset() {
      this.form = {
        poId: null,
        from: "",
        to: "",
        dateRequested: "",
        requestedBy: "",
        remarks: "",
        withLiquidatedDamages: true
      };
      this.extensionId = 0;
      this.fileUpload = null;
      this.contractActionType = 0;
      this.editExtension = false;
      this.minDate = "";
      this.submitted = false;
    },
    checkDeliveryDate(deliveryDate) {
      var today = new Date();
      var nextweek = new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + 7
      );
      if (deliveryDate <= today) return "expired";
      else if (deliveryDate < nextweek) return "warning";
      else return "ongoing";
    },
    checkForPending(array) {
      let checker = 0;
      array.forEach((item) => {
        if (item.status == "PENDING") {
          checker++;
        }
      });
      if (checker > 0) return true;
    },
    disabledRangeFrom(date) {
      if (this.form.to != "") return date > new Date(this.form.to);
    },
    disabledRangeTo(date) {
      if (this.form.from != "") return date < new Date(this.form.from);
    },
    uploadExtensionDocument(response, extensionId) {
      let extensionIndex = this.poDeliveryExtensions.findIndex(
        (item) => item.id == extensionId
      );
      this.poDeliveryExtensions[extensionIndex].extensionFiles.push(response);
    },
    openExtensionDocument(x) {
      this.readFile(x.id);
    },
    getExtensionAttachments(row) {
      row.viewFile = true;
      row.extensionFiles = [];
      row.attachmentLoading = true;
      this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: this.uploadOptionsExtension.type
        })
        .then((res) => {
          row.attachmentLoading = false;
          row.extensionFiles = res.data;
        })
        .catch(() => {
          row.attachmentLoading = false;
          this.showToast("Something went wrong - Getting documents!", "error");
        });
    },
    removeExtensionFile(extensionId, fileId) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!"
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", fileId)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let extensionIndex = this.poDeliveryExtensions.findIndex(
                (item) => item.id == extensionId
              );
              let fileIndex = this.poDeliveryExtensions[
                extensionIndex
              ].extensionFiles.findIndex((item) => item.id == fileId);
              this.poDeliveryExtensions[extensionIndex].extensionFiles.splice(
                fileIndex,
                1
              );
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be deleted!", "error");
            });
        }
      });
    },
    onFileChange() {
      if (this.$refs.uploadFile.files[0].size > 100 * 1024 * 1024) {
        this.showToast("File size should not exceed 100mb.", "error");
        return;
      }
      if (
        this.$refs.uploadFile.files[0].type !== "application/pdf" &&
        !this.$refs.uploadFile.files[0].type.includes("image")
      ) {
        this.showToast("Only pdf and images are allowed to upload", "error");
        return;
      }
      this.fileUpload = this.$refs.uploadFile.files[0];
    },
    async uploadToServer(id) {
      let data = {
        id: this.poItem.id,
        type: this.uploadOptions.type,
        folder: this.uploadOptions.folder,
        description: this.fileUpload.name.slice(0, -4),
        file: this.fileUpload
      };
      try {
        let response = await this.$store.dispatch(
          "filemanager/UploadFile",
          data
        );
        if (response.data.error) {
          return { error: true, message: response.data.errorMessage };
        }
      } catch (e) {
        return { error: true, message: "Something went wrong" };
      }

      data.id = id;
      data.type = this.uploadOptionsExtension.type;
      data.folder = this.uploadOptionsExtension.folder;
      try {
        let response = await this.$store.dispatch(
          "filemanager/UploadFile",
          data
        );
        if (response.data.error) {
          return { error: true, message: response.data.errorMessage };
        }
      } catch (e) {
        return { error: true, message: "Something went wrong" };
      }
    }
  }
};
</script>
<template>
  <div>
    <!-- Extend Date -->
    <b-modal id="modal-extension" :title="modalTitle" size="md" title-class="font-18" hide-footer no-close-on-backdrop>
      <form @submit.prevent="onExtend" class="needs-validation" ref="fcForm">
        <!-- Suspension - Show date range -->
        <div v-if="contractActionType == 0" class="mb-3">
          <label for="dateExpected">Range of Suspension </label>
          <div class="row">
            <div class="col-6">
              <date-picker v-model="form.from" :first-day-of-week="1" :disabled-date="disabledRangeFrom"
                @change="$forceUpdate()" lang="en" placeholder="Enter Suspension Start..." :class="{
                  'is-invalid':
                    submitted && (form.from == '' || form.from == null)
                }"></date-picker>
              <div v-if="submitted && (form.from == '' || form.from == null)" class="invalid-feedback">
                <span>This value is required.</span>
              </div>
            </div>
            <div class="col-6">
              <date-picker v-model="form.to" :first-day-of-week="1" :disabled-date="disabledRangeTo"
                @change="$forceUpdate()" lang="en" placeholder="Enter Suspension End..." :class="{
                  'is-invalid': submitted && (form.to == '' || form.to == null)
                }"></date-picker>
              <div v-if="submitted && (form.to == '' || form.to == null)" class="invalid-feedback">
                <span>This value is required.</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Extension - Show new delivery date -->
        <div v-if="contractActionType == 1" class="mb-3">
          <label for="dateExpected">New Date of Delivery </label>
          <date-picker v-model="form.to" :first-day-of-week="1" :disabled-date="disabledRangeTo"
            @change="$forceUpdate()" lang="en" placeholder="Enter date..." :class="{
              'is-invalid': submitted && (form.to == '' || form.to == null)
            }"></date-picker>
          <div v-if="submitted && (form.to == '' || form.to == null)" class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div>

        <!-- Termination - Show effective date -->
        <div v-if="contractActionType == 2" class="mb-3">
          <label for="dateExpected">Termination Date </label>
          <date-picker v-model="form.to" :first-day-of-week="1" lang="en" placeholder="Enter termination date..."
            :class="{
              'is-invalid': submitted && (form.to == '' || form.to == null)
            }"></date-picker>
          <div v-if="submitted && (form.to == '' || form.to == null)" class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div>

        <!-- Cancellation - Show effective date -->
        <div v-if="contractActionType == 3" class="mb-3">
          <label for="dateExpected">Cancellation Date </label>
          <date-picker v-model="form.to" :first-day-of-week="1" lang="en" placeholder="Enter cancellation date..."
            :class="{
              'is-invalid': submitted && (form.to == '' || form.to == null)
            }"></date-picker>
          <div v-if="submitted && (form.to == '' || form.to == null)" class="invalid-feedback">
            <span>This value is required.</span>
          </div>
        </div>

        <div v-if="userType == 'CREATE'">
          <div class="mb-3">
            <label for="requestedBy">Requested By </label>
            <input id="requestedBy" v-model="form.requestedBy" placeholder="Enter name..." class="form-control" :class="{
              'is-invalid':
                submitted &&
                (form.requestedBy == '' || form.requestedBy == null)
            }" autocomplete="off" />
            <div v-if="
              submitted &&
              (form.requestedBy == '' || form.requestedBy == null)
            " class="invalid-feedback">
              <span>This value is required.</span>
            </div>
          </div>
          <div class="mb-3">
            <label for="dateRequested">Date Requested </label>
            <date-picker v-model="form.dateRequested" :first-day-of-week="1" lang="en"
              placeholder="Enter Date Requested..." :class="{
                'is-invalid':
                  submitted &&
                  (form.dateRequested == '' || form.dateRequested == null)
              }"></date-picker>
            <div v-if="
              submitted &&
              (form.dateRequested == '' || form.dateRequested == null)
            " class="invalid-feedback">
              <span>This value is required.</span>
            </div>
          </div>
          <div class="mb-3">
            <label for="file">Upload File </label>
            <input id="file" type="file" placeholder="Upload file..." accept="image/png, image/jpeg, .pdf"
              ref="uploadFile" @change="onFileChange" class="form-control position-relative" :class="{
                'is-invalid':
                  submitted && (form.id == null || form.id == '' || form.id == 0) &&
                  (fileUpload == '' || fileUpload == null || fileUpload == [])
              }" autocomplete="off" />
            <div v-if="
              submitted && (form.id == null || form.id == '' || form.id == 0) &&
              (fileUpload == '' || fileUpload == null || fileUpload == [])
            " class="invalid-feedback">
              <span>This value is required.</span>
            </div>
          </div>
          <div class="mb-3">
            <label for="remarks">Description </label>
            <textarea id="remarks" rows="3" v-model="form.remarks" placeholder="Enter description..."
              class="form-control" autocomplete="off"></textarea>
          </div>
        </div>
        <div class="float-end">
          <button type="submit" class="btn btn-primary">Confirm</button>
        </div>
      </form>
    </b-modal>
    <!-- Approve/Deny -->
    <b-modal id="modal-upload-extension" :title="modalTitle" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <div class="mb-3">
        <label for="file">Upload File </label>
        <input id="file" type="file" placeholder="Upload file..." accept="image/png, image/jpeg, .pdf" ref="uploadFile"
          @change="onFileChange" class="form-control position-relative" :class="{
            'is-invalid':
              submitted &&
              (fileUpload == '' || fileUpload == null || fileUpload == [])
          }" autocomplete="off" />
        <div v-if="
          submitted &&
          (fileUpload == '' || fileUpload == null || fileUpload == [])
        " class="invalid-feedback">
          <span>This value is required.</span>
        </div>
      </div>
      <div class="float-end">
        <button @click="
          uploadExtensionType == 0
            ? onApproveExtension()
            : onDisapproveExtension()
          " class="btn btn-primary"> {{
            uploadExtensionType == 0 ? "Approve Request" : "Deny Request"
          }}
        </button>
      </div>
    </b-modal>
    <!-- Main -->
    <b-modal id="modal-contract" title="Contract Management" size="lg" title-class="font-18" hide-footer
      no-close-on-backdrop>
      <div v-if="poItem">
        <b-card-body v-if="loading" class="border">
          <div class="d-flex align-items-center justify-content-center">
            <div class="preloader-component me-2">
              <div class="status">
                <div class="spinner-chase w-25px h-25px">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <h5 class="mb-0">Loading...</h5>
          </div>
        </b-card-body>
        <div v-else>
          <div class="d-flex justify-content-between mb-3">
            <div>
              <div>{{ poItem.poNumber }}</div>
              <h5>{{ poItem.description }}</h5>
            </div>
            <div v-if="
              !checkForPending(poDeliveryExtensions) && userType == 'CREATE'
            " class="d-flex align-items-center flex-wrap" style="min-width: max-content">
              <b-dropdown text="Contract Actions" variant="primary" right class="ms-2">
                <b-dropdown-item v-for="actionType in contractActionTypes" :key="actionType.id" @click="actionType.id === 0 ? createSuspension() :
                  actionType.id === 1 ? createExtension() :
                    actionType.id === 2 ? createTermination() :
                      createCancellation()" :variant="actionType.btnClass">
                  <div class="d-flex align-items-center">
                    <i :class="'mdi ' + actionType.icon + ' me-2 fs-6'"></i>
                    <div>
                      <div class="fw-bold">{{ actionType.label }}</div>
                      <small v-if="actionType.id === 0">Temporarily pause contract for a specified period</small>
                      <small v-if="actionType.id === 1">Extend contract delivery date to a later time</small>
                      <small v-if="actionType.id === 2">End contract due to breach or non-performance</small>
                      <small v-if="actionType.id === 3">Cancel contract by mutual agreement</small>
                    </div>
                  </div>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <div v-if="poDeliveryExtensions.length == 0">
            <div class="d-flex align-items-center justify-content-between border mb-3 p-3">
              <p class="mb-0">
                <i>No prior extension</i>
              </p>
            </div>
          </div>
          <div v-else class="text-muted">
            <ul class="verti-timeline list-unstyled ms-4 me-0" v-for="y in poDeliveryExtensions" :key="y.id">
              <li class="event-list">
                <div class="event-timeline-dot pt-3">
                  <i class="bx bxs-right-arrow-circle" :class="y.status == 'APPROVED'
                    ? 'font-size-22 bx-fade-right text-success'
                    : y.status == 'DISAPPROVED'
                      ? 'font-size-18 text-danger'
                      : 'font-size-18 text-secondary'
                    "></i>
                </div>
                <div class="media ms-2">
                  <div class="media-body">
                    <div class="px-3 py-2 border" :class="y.status == 'APPROVED'
                      ? 'border-success'
                      : y.status == 'DISAPPROVED'
                        ? 'border-danger'
                        : ''
                      ">
                      <div>
                        <div class="d-flex align-items-center justify-content-between mb-2">
                          <div>
                            <div class="font-size-15 badge" :class="{
                              'bg-primary': y.type === 'SUSPENSION',
                              'bg-warning': y.type === 'EXTENSION',
                              'bg-danger': y.type === 'TERMINATION',
                              'bg-dark': y.type === 'CANCELLATION'
                            }">
                              {{ y.type }}
                            </div>
                            <div v-if="userType == 'POST' && y.status == 'PENDING'">
                              <div class="form-check form-checkbox-outline form-check-success">
                                <input type="checkbox" id="autoGenerate" checked="checked" class="form-check-input"
                                  @change="updateLiquidatedDamages(y)" v-model="y.withLiquidatedDamages" /><label
                                  for="autoGenerate" class="form-check-label">
                                  With Liquidated Damages
                                </label>
                              </div>
                            </div>
                            <div v-else-if="y.status != 'PENDING'">
                              {{ y.withLiquidatedDamages ? "With" : "Without" }}
                              Liquidated Damages
                            </div>
                          </div>
                          <div v-if="y.status == 'PENDING'" class="ms-2">
                            <div v-if="userType == 'POST'" class="d-flex align-items-center">
                              <b-dropdown size="sm" variant="primary" right>
                                <template #button-content>
                                  <i class="fas fa-cog me-1"></i> Actions
                                </template>
                                <b-dropdown-item variant="success" @click="approveExtension(y.id)" class="text-success">
                                  <i class="mdi mdi-check-circle-outline font-size-18 me-1"></i>Approve
                                </b-dropdown-item>
                                <b-dropdown-item variant="danger" @click="disapproveExtension(y.id)"
                                  class="text-danger">
                                  <i class="mdi mdi-close-circle-outline font-size-18 me-1"></i>Deny
                                </b-dropdown-item>
                              </b-dropdown>
                            </div>
                            <div v-else>
                              <b-dropdown size="sm" variant="primary" right>
                                <template #button-content>
                                  <i class="fas fa-cog me-1"></i> Actions
                                </template>
                                <b-dropdown-item v-if="userType == 'CREATE' || userType == 'IAR'"
                                  @click="approveExtension(y.id)" variant="success">
                                  <i class="mdi mdi-check-circle-outline font-size-18 me-1"></i>Approve
                                </b-dropdown-item>
                                <b-dropdown-item @click="updateExtension(y)" variant="info">
                                  <i class="mdi mdi-update font-size-18 me-1"></i>Update
                                </b-dropdown-item>
                                <b-dropdown-item @click="deleteExtension(y.id)" variant="danger">
                                  <i class="mdi mdi-trash-can font-size-18 me-1"></i>Delete
                                </b-dropdown-item>
                              </b-dropdown>
                            </div>
                          </div>
                          <div v-else-if="userType == 'POST'" class="ms-2">
                            <b-dropdown size="sm" variant="primary" right>
                              <template #button-content>
                                <i class="fas fa-cog me-1"></i> Actions
                              </template>
                              <b-dropdown-item @click="returnExtension(y.id)" class="text-warning">
                                <i class="mdi mdi-undo-variant font-size-18 me-1"></i>Undo
                              </b-dropdown-item>
                            </b-dropdown>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-6 border-end">
                            <div v-if="y.status == 'PENDING' && userType == 'POST'"
                              class="mb-1 d-flex align-items-center">
                              <b class="font-size-14 me-1">Details:</b>
                              <a href="javascript: void(0);" @click="updateExtension(y)">[Edit]</a>
                            </div>
                            <div v-if="y.type == 'EXTENSION'" class="font-size-12 mb-1">
                              Extension Date:
                              <b class="font-size-14">{{
                                formatDateShort(new Date(y.to))
                              }}</b>
                            </div>
                            <div v-if="y.type == 'SUSPENSION'" class="font-size-12 mb-1">
                              Suspension Date:
                              <b class="font-size-14">
                                {{ formatDateShort(new Date(y.from)) }} -
                                {{ formatDateShort(new Date(y.to)) }}</b>
                            </div>
                            <div v-if="y.type == 'TERMINATION'" class="font-size-12 mb-1">
                              Termination Date:
                              <b class="font-size-14">{{
                                formatDateShort(new Date(y.to))
                              }}</b>
                            </div>
                            <div v-if="y.type == 'CANCELLATION'" class="font-size-12 mb-1">
                              Cancellation Date:
                              <b class="font-size-14">{{
                                formatDateShort(new Date(y.to))
                              }}</b>
                            </div>
                            <div class="font-size-12 mb-1">
                              Date Requested:
                              <b class="font-size-14">{{
                                formatDateShort(new Date(y.dateRequested))
                              }}</b>
                            </div>
                            <div class="font-size-12 mb-1">
                              Requested By:
                              <b class="font-size-14">{{ y.requestedBy }}</b>
                            </div>
                            <div class="font-size-12 mb-1">
                              <div>Description:</div>
                              <div class="d-flex ms-3">
                                <div class="me-1">-</div>
                                <div>{{ y.remarks }}</div>
                              </div>
                            </div>
                          </div>
                          <div class="col-6">
                            <div class="font-size-12 mb-2">
                              Attachments:
                              <a href="javascript:void(0);" @click="getExtensionAttachments(y)"
                                :id="`viewSuspensionFiles-${y.id}`">[Show
                                attachments]</a>
                              <b-popover :target="`viewSuspensionFiles-${y.id}`" triggers="click" placement="right"
                                :show.sync="y.viewFile" custom-class="popover-supplier">
                                <template v-slot:title>
                                  <div class="d-flex align-items-center justify-content-between">
                                    <small>Attachments</small>
                                    <span class="bx bx-x font-size-14 cursor-pointer"
                                      @click="y.viewFile = false"></span>
                                  </div>
                                </template>
                                <table class="table table-bordered" v-if="
                                  !y.attachmentLoading &&
                                  y.extensionFiles.length > 0
                                ">
                                  <thead>
                                    <tr>
                                      <th>File Description</th>
                                      <th style="width: 30px"></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="z in y.extensionFiles" :key="z.id">
                                      <td @click="openExtensionDocument(z)" class="hoverable-link cursor-pointer">
                                        <div>
                                          {{ z.description }}
                                        </div>
                                        <small>{{
                                          formatDateWithTime(
                                            new Date(z.dateTimeUploaded)
                                          )
                                        }}</small>
                                      </td>
                                      <td>
                                        <i @click="
                                          removeExtensionFile(y.id, z.id)
                                          " class="cursor-pointer bx bx-trash text-danger"></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <div class="text-center" v-if="
                                  !y.attachmentLoading &&
                                  y.extensionFiles.length == 0
                                ">
                                  No data found
                                </div>
                                <div v-if="y.attachmentLoading" class="text-center">
                                  <b-spinner variant="primary" label="Loading..."></b-spinner>
                                </div>
                              </b-popover>
                            </div>
                            <div>
                              <button :id="`contract-document${y.id}`" type="button"
                                class="btn btn-sm btn-outline-success" @click="y.addDocu = true">
                                <i class="bx bx-plus"></i>Add Attachments
                              </button>
                              <upload-popover :option="uploadOptionsExtension" :sourceId="y.id" @uploaded="
                                uploadExtensionDocument($event, y.id)
                                " :showPV="y.addDocu" @closePopover="y.addDocu = false"
                                :dzId="`dropzone-contract${y.id}`" :pvId="`contract-document${y.id}`"></upload-popover>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<style>
.p-0 .popover-body {
  padding: 0 !important;
}
</style>
